// TODO: wrap inside IIFE

var menuLoaded = false;

$(document).ready(function () {
	
	var menuBtn = '.settingsMenu';
	var menuDiv = '#settingsMenu';
	var hamburgerIcon = '.header_hamburger';
	var speedMenuOpen = 200;

	//de header heeft een begin z-index waarde van 5000
	$("header").css("z-index", '5000');

	$(menuBtn).click(function() {

		if (!menuLoaded) {
			loadMenu();
			menuLoaded = true;
		} else {
			
			if ($(menuDiv).hasClass('menuOn')) {
				closeMenu();
			} else {
				openMenu();
			}
			
		}
		
	});

	// if 'menu' is present on the url the respective item must be expanded
	var stringURL = getUrlVars()['menu'];
	if (typeof stringURL != 'undefined' && stringURL != '') {
		//explode op / of %2f zodat je ook dieper kan komen in de menu
		stringURL = decodeURIComponent(stringURL);
		var arrMenu = stringURL.split("/");
		openMenuFromURL(arrMenu);
	}
	
	
	function loadMenu() {
		$.ajax({
			type: 'GET',
			url: '/ajax/open_menu.php',
			data: {visit : getUrlVars()['visit']}
		}).then(function(menuData) {
			$('#settingsMenu').html(menuData);
			ko.applyBindings({user: new User()}, document.getElementById('settingsMenu'));
			
			openMenu();
			
			// insert tagmodule
			$('.tags_personal').tagModule({'scriptLocation':'/autocomplete.php',
			                               'displayFunc' : displayHideTagPersonal,
			                               'removeTagHook' : removeHideTagPersonal,
			                               'spanTagClass' : 'cloud_personal_tag'});
			
			// insert tagmodule
			 $('.tags').tagModule({'scriptLocation':'/autocomplete.php',
			                       'displayFunc' : displayHideTag,
			                       'removeTagHook' : removeHideTag,
			                       'spanTagClass' : 'tag_item'});
			
			
			$('#personalTagForm fieldset').hide();
			$('.remove').hide();
			$('#filterTagForm fieldset').hide();
			
			$('.settingContent').addClass('hideSettingContent');
			$('.moreFilterTags').hide();
			
			$('#settingsMenu > a.settingQuickLink').click(function() {
				var item = $(this);
				
				if (item.hasClass('menu-item-open')) {
					closeMenuItem(item);
				} else {
					openMenuItem(item);
				}
				
				if (checkIfMenuItem(item)) {
					return false;
				}
			});
			
			//sub sub menu click
			$('div.settingContent > div.settingContent > a.childContentSub').click(function() {
				var item = $(this);
				
				if (item.hasClass('menu-item-open')) {
					closeMenuItem(item, true);
				} else {
					openMenuItem(item, false);
					anchorThis(item);
				}
				
				if (checkIfMenuItem(item)) {
					return false;
				}
				
			});
			
			$('div.settingContent > a.childContent').click(function() {
				var item = $(this);
				
				if (item.hasClass('menu-item-open')) {
					closeMenuItem(item, true);
				} else {
					openMenuItem(item, false);
					anchorThis(item);
				}
				
				if (checkIfMenuItem(item)) {
					return false;
				}
				
			});
			
			updatePresent();
			
			personalTagsLength = $('#tagPersonal > div').length;
			filterTagsLength   = $('#tag > div').length;
			
			fetchDevicePreferences();
		});
	}
	
	//close menu when click outside of menu
	$("#wrapper").on('click', function(e) {

		var target = $(e.target);

		// if user wants to logout then closing the menu is irrelevant
		if (target.is('#logout')) {
			return;
		}

		//omdat menubtn in header zit checken of je niet de menubtn aanklikt en check fo je niet in de menu klikt
		if ($(menuDiv).hasClass('menuOn') && target.attr("class") != 'openSnelTags' &&
		   !target.closest(menuBtn).length && !target.closest("#settingsMenu").length &&
		    target.attr("class") != 'remove' && target.id != 'logout') {
			closeMenu();
		}
	});
	
	//snelle tags + klik moet snelle tags editor in menu openen
	$(document).on('click', ".openSnelTags", function(e) {
		
		if (!$(menuDiv).hasClass('menuOn')) {
			$('.settingsMenu').click();
		}
		
		var waitTimer = setInterval(function(){
			
			if (menuLoaded) {
				showFilterFormPersonal();
				showRemoveAllTags("personal");
				$('.personal_tag_form .acInput').focus();
				
				clearInterval(waitTimer);
			}
		}, 500);
		
	});
	
	$(document).on('click', ".showFilterTags", function(e) {
		$('.moreFilterTags').show();
		$('.showFilterTags').addClass('removeFilterTags');
		$('.showFilterTags').removeClass('showFilterTags');
	});
	
	$(document).on('click', ".removeFilterTags", function(e) {
		$('.moreFilterTags').hide();
		$('.removeFilterTags').addClass('showFilterTags');
		$('.removeFilterTags').removeClass('removeFilterTags');
	});
	
	//notificaties app all klik
	$(document).on('change', "#appAlle", function() {
		$('.appGroup').prop('checked', false);
		$('#appNone').prop('checked', false);
		$('#appCertain').prop('checked', false);
	});
	
	$(document).on('change', "#appCertain", function() {
		$('#appAlle').prop('checked', false);
		$('#appNone').prop('checked', false);
		$('#appBreaking').click();
	}); 
	
	//geen optie klik
	$(document).on('change', "#appNone", function() {
		//uncheck alle andere
		$('#appAlle').prop('checked', false);
		$('#appCertain').prop('checked', false);
		$('.appGroup').prop('checked', false);
	});
	
	$(document).on('change', ".appGroup", function() {
		$('#appNone').prop('checked', false);
		$('#appAlle').prop('checked',false);
		$('#appCertain').prop('checked', true);
	});
	
	
	//notificaties mail all klik
	$(document).on('change', "#mailAlle", function() {
		$('.emailGroup').prop('checked', false);
		$('#mailNone').prop('checked', false);
		$('#mailCertain').prop('checked', false);
	});
	
	$(document).on('change', "#mailCertain", function() {
		$('#mailAlle').prop('checked', false);
		$('#mailNone').prop('checked', false);
		$('#mailBreaking').click();
	});
	
	//geen klik
	$(document).on('change', "#mailNone", function(e) {
		$('#mailAlle').prop('checked', false);
		$('#mailCertain').prop('checked', false);
		$('.emailGroup').prop('checked', false);
	});
	
	$(document).on('change', ".emailGroup", function() {
		$('#mailNone').prop('checked', false);
		$('#mailAlle').prop('checked',false);
		$('#mailCertain').prop('checked', true);
	});
	
	
	$(document).on('change', ".appNotification", function() {
		var appForm = $('#appNotificationForm').serializeArray();
		$.ajax({
			type: 'GET',
			url: '/ajax/notifications.php',
			data: { mode:'app', form:appForm }
		});
	});
	
	$(document).on('change', ".mailNotification", function() {
		var appForm = $('#mailNotificationForm').serializeArray();
		$.ajax({
			type: 'GET',
			url: '/ajax/notifications.php',
			data: { mode:'mail', form:appForm }
		});
	});
	
	$(document).on('click','.inviteSubmitButton', function() {
		clickedInviteButton = $(this).attr('id');
		
		var name  = document.getElementById(clickedInviteButton+'_fullname').value;
		var email = document.getElementById(clickedInviteButton+'_email').value;
		
		$.ajax({
			type: 'GET',
			url:  '/ajax/invite.php',
			data: { name: name, email: email, mode:'sendInvite' },
			success: function(data) {
				$('.errorPresent').show();
				$('.errorPresent').html(data);
				
				checkPresent();
			}
		});
	});
	
	$(document).on('click','.reInviteSubmit', function(e) {
		var name   = $(this).parent().find('.reInviteName').val();
		var email  = $(this).parent().find('.reInviteEmail').val();
		var refkey = $(this).parent().find('.reInviteRefkey').val();
		
		$.ajax({
			type: 'GET',
			url:  '/ajax/invite.php',
			data: { name: name, email: email, mode:'resendInvite',refkey:refkey },
			success: function(data) {
				$('.errorPresent').show();
				$('.errorPresent').html(data);
				
				checkPresent();
			}
		});
	});

	$(document).on('click','.optionsAccount', function() {
		saveDevicePreferences();
	});
	
	function checkPresent() {
		$.ajax({
			type: 'GET',
			url: '/ajax/invite_form.php',
			data: { 'mode': 'getInvite'}
		}).done(function(data) {
			$('.menuCadeau').next().children('fieldset').html(data);
			updatePresent();
		});
	}
	
	// Checks if item has ?menu href to stop redirecting.
	function checkIfMenuItem(item) {
		
		var href = item.attr('href');
		
		if (typeof href !== 'undefined') {
			var subHref = href.substring(0, 5);
			
			// Do not redirect if it opens an menu item
			if (subHref == '?menu') {
				return true;
			}
		}
		
		return false;
	}
	
	function updatePresent() {
		if ($('.inviteWaitTime').length === 1) {
			var count = $('.inviteWaitTime').html();
			
			var waitTimer = setInterval(function(){
				count--;
				$('.inviteWaitTime').html(count);
				if (count <= 0) {
					$.ajax({
						type: 'GET',
						url: '/ajax/invite_form.php',
						data: { 'mode': 'getInvite'}
					}).done(function(data) {
						$('.menuCadeau').next().children('fieldset').html(data);
					});
					clearInterval(waitTimer);
				}
			}, 1100);
		}
	}
	
	function closeMenuItem(item, colorSet) {
		$(item).next(".settingContent").stop().slideUp(speedMenuOpen);
		item.removeClass('menu-item-open');
		item.removeClass('settingColoured');
		
		//als die in submenu zit
		if(item.parent().hasClass("settingContent") && colorSet) {
			item.parent().prev('.settingQuickLink').addClass('settingColoured');
		}
	}
	
	
	function openMenuItem(item, colorSet) {
		
		$('.settingColoured').removeClass('settingColoured');
		item.addClass('settingColoured');
		
		$(item).parent().find('a.settingQuickLink').each(function() {
			var item2 = $(this);
			if (item[0] != item2[0]) {
				if (item2.hasClass('settingColoured') && !item2.hasClass('menu-item-open')) {
					item2.removeClass('settingColoured');
				}
				if (item2.hasClass('menu-item-open')) {
					closeMenuItem(item2, colorSet);
				}
				
			}
		});
		
		$('a.settingQuickLink').each(function() {
			var item2 = $(this);
			if (item[0] != item2[0]) {
				if (item2.hasClass('settingColoured') && !item2.hasClass('menu-item-open')) {
					item2.removeClass('settingColoured');
				}
				
			}
		});
		
		$(item).next(".settingContent").stop().slideDown(speedMenuOpen);
		item.addClass('menu-item-open');
	}
	
	function anchorThis(item) {
		var top = item.offset().top;
		$('#settingsMenu').animate({
			scrollTop: top
		}, speedMenuOpen);
	}
	
	function openMenu() {
		//animate hamburger menu to a exit icon
		$(hamburgerIcon).addClass("is_active");
		//fade in web_overlay (het grijze vlak over de inhoud)
		$('.web_overlay').fadeIn(500);
		//geef header geen z-index zodat de menu button alleen wit is
		$("header").css("z-index", '');
		$(menuDiv).css('left', 'auto'); 
		$(menuDiv).addClass('menuOn');
		$('#wrapper').css('overflowX', 'hidden');
		$('.shiftMenu').addClass('slideMenu');
		$('#container a').bind('click', function(e){
			e.preventDefault();
		});
	}
	
	function closeMenu() {
		$(menuDiv).css('left', '-325px'); 
		$(menuDiv).removeClass('menuOn');
		$('.shiftMenu').removeClass('slideMenu');
		$('#wrapper').css('overflow', 'auto');
		$('#container a').unbind('click');
		// animate hamburger icon back to its normal state
		$(hamburgerIcon).removeClass("is_active");
		//geed header weer een z-index
		$("header").css("z-index", '5000');
		// fade out web overlay (het grijze vlak over de inhoud)
		$('.web_overlay').fadeOut(500);
		if ($('.personal_tag_form').hasClass('filter_form_open')) {
			$('#personal').click();
		}
	}
	
	function removeHideTag(tag, id) {
		$('.removeTagLabel').each(function() {
			if ($(this).html().toLowerCase().trim() == tag.toLowerCase().trim()) {
				$('#'+$(this).attr('for')).prop('checked', false);
			}
		});
		insertFilterTags();
	}
	
	function displayHideTag(tag,id,spanTagClass) {
		$('.removeTagLabel').each(function() {
			if ($.trim($(this).html().toLowerCase()) == $.trim(tag.toLowerCase())) {
				$('#'+$(this).attr('for')).prop('checked', true);
			}
		});
		$('#tag > input').attr('placeholder','');
		return $('<div>').append(
			$('<input>', { type: 'hidden', value: tag }),
			$('<a>', { 'class': spanTagClass, 'href':'index?tag='+tag, text: tag, style: 'background-color: #F00;' }),
			"<span class='remove'>x</span>"
		);
	}
	
	
	function removeHideTagPersonal(tag, id) {
		
		$('.removeTagLabelPersonal').each(function() {
			if ($(this).html().toLowerCase().trim() == tag.toLowerCase().trim()) {
				$('#'+$(this).attr('for')).prop('checked', false);
			}
		});
		insertPersonalTags();
	}
	
	function displayHideTagPersonal(tag,id, spanTagClass) {
		
		$('#tagPersonal > input').attr('placeholder','');
		
		var tagLowerCase = $.trim(tag.toLowerCase());
		var url = fetchLinkPersonalTags(tagLowerCase);
		var shortLinks = ['belangrijk','vandaag','gisteren','eergisteren'];
		
		$('.removeTagLabelPersonal').each(function() {
			if ($.trim($(this).html().toLowerCase()) == tagLowerCase) {
				$('#'+$(this).attr('for')).prop('checked', true);
			}
		});
		
		if ($.inArray(tagLowerCase, shortLinks) == -1) {
			return $('<div>').append($('<input>', { type: 'hidden', value: tag }),
		                             $('<a>', { 'class': spanTagClass, 'href': url, text: tag}),
		                             "<span class='remove'>x</span>");
		} else {
			return $('<div>').append($('<input>', { type: 'hidden', value: tag }));
		}
		
	}
	
});


function getUrlVars() {
	var vars = {};
	var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
		vars[key] = value;
	});
	return vars;
}

//menu openen doormiddel van url menu parameters
function openMenuFromURL(arrayMenu) {
	//open menu zelf
	$('.settingsMenu').click();
	if (arrayMenu != '') {
		var numMenu = 1;
		var waitTimer = setInterval(function(){
			if (menuLoaded) {
				
				// Menu is standaard open dus doe cadeau dicht
				$('.menuCadeau').removeClass('menu-item-open');
				
				arrayMenu.forEach(function(element) {
					//kijk of de element die aangeklikt moet worden wel in de menu zit
					if($('.'+element,'#settingsMenu').length >= 1) {
						$('.'+element).addClass('menu-item-open');
						if (numMenu == arrayMenu.length) {
							$('.'+element).addClass('settingColoured');
						}
					}
					numMenu++;
				});
				clearInterval(waitTimer);
			}
		}, 1000);
	}
}

function removePersonalTag(tagID) {

	$.ajax({
		type: 'GET',
		url: '/ajax/ptagsajax.php',
		dataType: 'json',
		data: {mode : 'pg', id : tagID}
	}).done(function(data) {
		var name = $('#personaltags' + tagID).find('.fake_tag').text();
		var count = parseInt(data[1], 10);
		
		if (count == 0) return;
		
		var message;
		if (count == 1) {
			message = "Weet u zeker dat u bij "+ count +" item de tag "+ name +"wilt verwijderen?";
		} else {
			message = "Weet u zeker dat u bij alle "+ count +" items de tag "+ name +"wilt verwijderen?";
		}
		
		if (confirm(message)) {
			$.ajax({
				type: 'GET',
				url: '/ajax/ptagsajax.php',
				data: {mode : 'pd', id : tagID}
			}).done(function() {
				$('#personaltags' + tagID).fadeOut();
			});
		}
	});
}

// fetch device preferences and update checkboxes
// IN:
//UIT:
function fetchDevicePreferences() {

	$.ajax({
		url: '/ajax/device',
		type: 'GET',
		dataType: 'JSON'
	}).then(function(data) {

		if (data.open_newtab == '1') {
			$('#tabCheckbox').prop('checked', true);
		}
		if (data.serif == '1') {
			$('#serifCheckbox').prop('checked', true);
		}
	});

}

// save changes in the device preferences and perform required changes for an inmediate layout update
// IN:
//UIT:
function saveDevicePreferences() {


	var openNewTab;
	var serifFont;

	if ($('#tabCheckbox').is(":checked")) {
		openNewTab = 1;
	} else {
		openNewTab = 0;
	}

	if ($('#serifCheckbox').is(":checked")) {
		serifFont = 1;
		$('body').addClass('serif');
	} else {
		serifFont = 0;
		$('body').removeClass('serif');
	}

	var data = {open_newtab: openNewTab, serif: serifFont};

	$.ajax({
		     url: '/ajax/device',
		    type: 'POST',
		dataType: 'JSON',
		    data: { data: JSON.stringify(data) }
	}).then(function(data) {
		if (typeof data.messageError !== 'undefined') {
			$('#devicePreferenceError').show();
			$('#devicePreferenceError li').text(data.messageError);
		} else {
			$('#devicePreferenceSuccess').show();
			$('#devicePreferenceSuccess li').text(data.messageSuccess);
		}
		
	});
}


var User = function() {
	
	var self = this;
	
	self.fullname  = ko.observable('');
	self.alias     = ko.observable('');
	self.email     = ko.observable('');
	self.birthyear = ko.observable('');
	self.gender    = ko.observable('');
	
	self.pass0     = ko.observable('');
	self.pass1     = ko.observable('');
	self.pass2     = ko.observable('');
	
	// Handles retrieving of user data
	self.fetch = function(resetErrors) {
		
		if (typeof resetErrors == 'undefined') {
			resetErrors = true;
		}
		
		$.ajax({
			     url: '/ajax/settings',
			    type: 'GET',
			dataType: 'JSON'
		}).then(function(data) {
			
			self.fullname(data.fullname);
			self.email(data.email);
			self.alias(data.alias);
			self.birthyear(data.birthyear);
			self.gender(data.gender);
			
			self.messagesError([]);
			
			// Reset password fields
			self.pass0('');
			self.pass1('');
			self.pass2('');
			
			// reset errors
			if (resetErrors) {
				self.messages([]);
			}
		});
	};
	
	self.messages = ko.observableArray();
	self.messagesError = ko.observableArray();
	
	self.save = function() {
		
		self.messages([]);
		self.messagesError([]);
		
		$.ajax({
			     url: '/ajax/settings',
			    type: 'POST',
			dataType: 'JSON',
			    data: { data: ko.toJSON(self) }
		}).then(function(data) {
			if (typeof data.status !== 'undefined') {
				self.messages(data.messages);
			} else {
				self.messagesError(data.messages);
			}
		});
	};
	
	self.fetch();
};

// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
